/** @jsxImportSource @emotion/react */

import { FC } from "react";
import Row from "../../../../Grid/Row";
import TableColumn from "./TableColumn";
import useIsMobile from "../../../../../hooks/useIsMobile";

interface TableDataProps {
  label: string;
  value: string | JSX.Element;
}

interface DetailsTableProps {
  data: TableDataProps[][];
}

const DetailsTable: FC<DetailsTableProps> = ({ data }) => {
  const isMobile = useIsMobile();
  return (
    <Row noGutters align="center" justify="center">
      {!isMobile && (
        <TableColumn
          column={data[0]}
          mobile={isMobile}
          hideValues
          columnsQuantity={data.length}
        />
      )}
      {data.map((col, i) => (
        <TableColumn
          key={`table-column-${i}`}
          column={col}
          mobile={isMobile}
          hideLabels
          columnsQuantity={data.length}
        />
      ))}
    </Row>
  );
};

export default DetailsTable;
